import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Flag } from "lucide-react";

const REASONS = ["Inappropriate behaviour", "Fake profile", "Harassment", "Made me uncomfortable", "Other"];

export function ReportDialog({ reportedId, matchId, trigger, onBlocked }) {
  const [open, setOpen] = useState(false);
  const [reason, setReason] = useState("");
  const [details, setDetails] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (block) => {
    if (!reason) { toast.error("Pick a reason"); return; }
    setBusy(true);
    try {
      await api.post("/report", { reported_id: reportedId, match_id: matchId, reason, details });
      if (block) { await api.post("/block", { blocked_id: reportedId }); onBlocked?.(); }
      toast.success(block ? "Reported & blocked" : "Report submitted. Our team will review it.");
      setOpen(false); setReason(""); setDetails("");
    } catch { toast.error("Could not submit"); }
    finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild data-testid="report-trigger">
        {trigger || <Button variant="ghost" size="sm" className="text-pink-300"><Flag className="h-4 w-4 mr-1.5" /> Report</Button>}
      </DialogTrigger>
      <DialogContent className="glass border-amber-500/20">
        <DialogHeader><DialogTitle className="font-display">Report or block</DialogTitle></DialogHeader>
        <div className="space-y-2">
          {REASONS.map((r) => (
            <button key={r} data-testid={`report-reason-${r}`} onClick={() => setReason(r)}
              className={`w-full text-left px-4 py-2.5 rounded-xl text-sm border transition-all ${reason === r ? "bg-pink-500/20 border-pink-400/40 text-pink-100" : "border-white/10 text-emerald-100/70"}`}>
              {r}
            </button>
          ))}
        </div>
        <Textarea data-testid="report-details" value={details} onChange={(e) => setDetails(e.target.value)}
          placeholder="Add details (optional)" className="bg-white/5 border-white/10 rounded-xl" />
        <div className="flex gap-3">
          <Button data-testid="report-submit" disabled={busy} onClick={() => submit(false)} variant="outline" className="flex-1 rounded-full border-white/15">
            Report only
          </Button>
          <Button data-testid="report-block" disabled={busy} onClick={() => submit(true)} className="flex-1 btn-pink rounded-full">
            Report & block
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
